<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.header-dropdown {
  color: #4182EB;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px 10px 20px;

  .header-container-name {
    height: 30px;
    line-height: 30px;
  }
}

.pileItem-div {
  font-weight: 600;
  margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}

.share-info-block {
  margin: 10px 10px 20px;
}

.share-info-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px 10px 0;
}

.share-info-item {
  display: flex;
  align-items: center;
}

.share-info-label {
  font-size: 14px;
  color: #8F9BB3;
  margin-right: 8px;
  white-space: nowrap;
}

.share-info-input {
  width: 120px;
}

.share-info-input /deep/ .el-input__inner {
  text-align: center;
}

.share-info-action {
  margin-top: 20px;
  padding-right: 10px;
  text-align: right;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }
}

.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}

img {
  width: 200px;
  height: 100px;
  margin-right: 10px;
}

.pileItem-div {
  font-weight: 600;
  margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">
      共享设备信息
      <el-dropdown @command="handleCommand">
        <div class="flex-r header-dropdown">
          <p class="header-container-name">{{ custInfo.pileCode }}</p>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="i in pileList" :key="i.pileCode" :command="i.pileCode">{{ i.pileCode
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <button class="common-bg-button" style="margin-left: 12px;" @click="handleResetIdentityAuth">重新开通身份认证</button>
    </div>
    <div class="share-info-block">
      <span class="pileItem-div">共享信息</span>
      <div class="share-info-row">
        <div class="share-info-item">
          <span class="share-info-label">账号类型</span>
          <el-input type="text" disabled size="small" v-model="custInfo.custType" class="share-info-input" />
          <button type="button" class="common-bg-button" style="margin-left: 10px;" @click="handleViewSharedDevice" v-if="custInfo.custType !== '共享充电账号'">查看共享设备信息</button>
        </div>
        <div class="share-info-item">
          <span class="share-info-label">是否开通共享</span>
          <el-input type="text" disabled size="small" v-model="custInfo.shareActiveName" class="share-info-input" />
        </div>
      </div>
      <!-- 共享消息偏好管理 -->
      <el-col :span="24"><span class="pileItem-div">共享消息偏好管理</span></el-col>
      <div style="margin: 0 10px 20px;">
        <ZD-table :tableColumns="messagePreferenceColumns"
                  :operates="[]"
                  :tableData="messagePreferenceList"
                  :tableConfig="messagePreferenceTableConfig">
        </ZD-table>
      </div>

      <!-- 共享消息通知日志 -->
      <el-col :span="24"><span class="pileItem-div">共享消息通知日志</span></el-col>
      <div style="margin: 0 10px 20px;">
        <ZD-table :tableColumns="messageLogColumns"
                  :operates="[]"
                  :tableData="messageLogList"
                  :tableConfig="messageLogTableConfig">
        </ZD-table>
        <div class="list-pagination">
          <ZD-pagination :pagination="messageLogPagination"
                         v-on:pageUpdate="getMessageLog">
          </ZD-pagination>
        </div>
      </div>

      <!-- 共享站点收藏列表 -->
      <el-col :span="24"><span class="pileItem-div">共享站点收藏列表</span></el-col>
      <div style="margin: 0 10px 20px;">
        <ZD-table :tableColumns="shareFavoriteListColumns"
                  :operates="[]"
                  :tableData="shareFavoriteList"
                  :tableConfig="shareFavoriteListTableConfig">
        </ZD-table>
        <div class="list-pagination">
          <ZD-pagination :pagination="shareFavoriteListPagination"
                         v-on:pageUpdate="getShareFavoriteList">
          </ZD-pagination>
        </div>
      </div>
      <div class="share-info-action">
        <button class="common-empty-button" @click="back()">返 回</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from '../../cust-manage/page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置

      custInfo: {}, // 列表信息
      pileList: [],

      // 共享消息偏好管理（展开 DTO 的 4 个开关为 4 行展示）
      messagePreferenceList: [],
      messagePreferenceColumns: [
        { label: '消息分类',  props: 'categoryName',  minWidth: 150 },
        { label: '是否接收',  props: 'receiveText',   minWidth: 100 },
        { label: '创建时间',  props: 'createdWhen',   minWidth: 160 },
        { label: '更新时间',  props: 'lastModifiedWhen', minWidth: 160 },
      ],
      messagePreferenceTableConfig: { showSelection: false, showIndex: true },

      // 共享消息通知日志
      messageLogList: [],
      messageLogColumns: [
        { label: '消息一级分类',     props: 'msgTypeName',    minWidth: 100 },
        { label: '消息二级分类',     props: 'title',           minWidth: 160 },
        { label: '消息内容',         props: 'content',         minWidth: 250 },
        { label: '消息关联用户账号', props: 'senderMobile',    minWidth: 140 },
        { label: '消息关联设备编号', props: 'deviceCode',      minWidth: 150 },
        { label: '推送时间',         props: 'createdWhen',     minWidth: 160 },
      ],
      messageLogTableConfig: { showSelection: false, showIndex: true },
      messageLogPagination: { current: 1, total: 0, pageSize: 10, pageSizes: [10, 20, 50, 100] },

      // 共享站点收藏列表
      shareFavoriteList: [],
      shareFavoriteListColumns: [
        { label: '收藏设备名称',       props: 'shareStationName',  minWidth: 150 },
        { label: '站点地址',           props: 'stationAddress',    minWidth: 200 },
        { label: '收藏设备编号',       props: 'deviceCode',        minWidth: 140 },
        { label: '收藏站点设备主账号', props: 'custMobile',        minWidth: 130 },
        { label: '收藏时间',           props: 'favoriteTime',      minWidth: 150 },
        { label: '更新时间',           props: 'lastModifiedWhen',  minWidth: 150 },
      ],
      shareFavoriteListTableConfig: { showSelection: false, showIndex: true },
      shareFavoriteListPagination: { current: 1, total: 0, pageSize: 10, pageSizes: [10, 20, 50, 100] },
    }
  },
  methods: {
    init() {
      let _ = this;
      if (_.$store.state.custObj) {
        _.custInfo = _.$store.state.custObj;
      }
      // 收藏列表由 watch.$store.state.custObj (immediate:true) 触发首次加载，
      // 避免 mounted 时 custObj 未就绪导致静默跳过
    },

    // 共享消息偏好查询：将 DTO 的 4 个开关字段展开为 4 行数组
    getMessagePreference() {
      const _ = this
      const custNo = _.custInfo?.custNo
      if (!custNo) {
        _.messagePreferenceList = []
        return
      }
      _.$H.post(_, _.$A.digitization.shareMessagePreference, { custNo }).then((res) => {
        const dto = res?.data?.data
        if (!dto) {
          _.messagePreferenceList = []
          return
        }
        // 将 DTO 的 4 个开关字段展开为 4 行表格数据
        const categoryMap = [
          { field: 'favoriteNotify', name: '收藏通知' },
          { field: 'reserveNotify',  name: '预约通知' },
          { field: 'chargeNotify',   name: '充电通知' },
          { field: 'systemNotify',   name: '系统通知' },
        ]
        _.messagePreferenceList = categoryMap.map(item => ({
          categoryName: item.name,
          receiveText: dto[item.field] === 'Y' ? '是' : '否',
          createdWhen: dto.createdWhen,
          lastModifiedWhen: dto.lastModifiedWhen,
        }))
      }).catch(() => {
        _.messagePreferenceList = []
      })
    },

    // 共享消息通知日志查询（分页）
    getMessageLog() {
      const _ = this
      const custNo = _.custInfo?.custNo
      if (!custNo) {
        _.messageLogList = []
        _.messageLogPagination.total = 0
        return
      }
      const params = {
        custNo,
        pageNum: _.messageLogPagination.current - 1,  // 后端 pageNum 从 0 开始
        pageSize: _.messageLogPagination.pageSize,
      }
      _.$H.post(_, _.$A.digitization.shareMessageLog, params).then((res) => {
        const page = res?.data?.data || {}
        const list = (page.content || []).map(item => ({
          ...item,
          // 消息一级分类映射为中文
          msgTypeName: ({ FAVORITE: '收藏', RESERVE: '预约', CHARGE: '充电', SYSTEM: '系统' })[item.msgType] || item.msgType,
        }))
        _.messageLogList = list
        _.messageLogPagination.total = page.totalElements || 0
      }).catch(() => {
        _.messageLogList = []
        _.messageLogPagination.total = 0
      })
    },

    // 拉取共享站点收藏列表（按当前用户 custNo 查询其收藏记录）
    getShareFavoriteList() {
      const _ = this
      const custNo = _.custInfo?.custNo
      if (!custNo) {
        // custObj 未携带 custNo 时清空列表，避免展示脏数据
        console.warn('[shared-detail] custNo 缺失，跳过收藏列表查询。当前 custInfo:', JSON.stringify(_.custInfo))
        _.shareFavoriteList = []
        _.shareFavoriteListPagination.total = 0
        return
      }
      const params = {
        custNo,
        pageNum: _.shareFavoriteListPagination.current - 1,  // 后端 pageNum 从 0 开始
        pageSize: _.shareFavoriteListPagination.pageSize,
      }
      _.$H.post(_, _.$A.digitization.shareFavoriteList, params).then((res) => {
        const page = res?.data?.data || {}
        _.shareFavoriteList = page.content || []
        _.shareFavoriteListPagination.total = page.totalElements || 0
      }).catch(() => {
        // 接口异常时清空列表，不影响上方"共享信息"模块的展示
        _.shareFavoriteList = []
        _.shareFavoriteListPagination.total = 0
      })
    },

    handleCommand(val) {
      let _ = this;
      _.custInfo.pileCode = val;
    },

    handleResetIdentityAuth() {
      const _ = this
      const deviceCode = _.custInfo?.pileCode
      const deviceType = _.custInfo?.deviceType
      if (!deviceCode || !deviceType) {
        _.$U?.error ? _.$U.error('缺少deviceCode或deviceType') : _.$message.error('缺少deviceCode或deviceType')
        return
      }
      _.$confirm('确认重新开通身份认证？', '二次确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = { deviceCode, deviceType }
        _.$U.showLoading(_)
        _.$H.post(_, _.$A.cust.resetSharePileBasicInfo, params).then((res) => {
          if (res.data && res.data.status === 200) {
            _.$U?.success ? _.$U.success('操作成功') : _.$message.success('操作成功')
          } else {
            _.$U?.error ? _.$U.error(res.data?.message || '操作失败') : _.$message.error(res.data?.message || '操作失败')
          }
        }).catch((err) => {
          _.$U?.error ? _.$U.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '请求失败，请稍后重试') : _.$message.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '请求失败，请稍后重试')
        }).finally(() => {
          _.$U.hideLoading(_)
        })
      }).catch(() => {
        // 用户取消二次确认不做额外提示
      })
    },

    // 根据绑定设备类型跳转到对应设备管理页详情的「私桩共享信息」tab（tab 6）
    // deviceType 取值：CHARGE_POINT（充电桩）/ CHARGE_LOCK（共享开关）
    handleViewSharedDevice() {
      const _ = this
      const pileCode = _.custInfo?.pileCode
      const deviceType = _.custInfo?.deviceType
      if (!pileCode) {
        _.$U.error('当前用户未绑定共享设备')
        return
      }
      // 写入 store.pileObj：custObj 的设备编码字段名为 pileCode，但共享开关版目标页
      // share-switch/pile-datail.vue:344 读 list.deviceCode（无 pileCode 回退），
      // 故写入时需补齐 deviceCode 字段；充电桩版目标页 pile-datail.vue:343 已支持
      // list.deviceCode || list.pileCode 回退，但补齐后两边行为一致更稳健
      const payload = { ..._.custInfo, deviceCode: pileCode }
      _.$store.commit('setPileObj', payload)

      let routeName
      if (deviceType === 'CHARGE_LOCK') {
        routeName = 'shareSwitchDetail'
      } else if (deviceType === 'CHARGE_POINT') {
        routeName = 'pileDetail'
      } else {
        _.$U.error('未知的设备类型：' + (deviceType || '空'))
        return
      }

      const url = _.$router.resolve({
        name: routeName,
        query: { parent: 6 }
      })
      window.open(url.href, '_blank')
    },

    back() {
      this.$router.push({
        name: "custList"
      })
    },
  },
  watch: {
    // 监听 store 中 custObj 变化，确保 custObj 就绪后自动触发收藏列表查询
    // 与 cust-detail.vue 保持一致，解决 v-if 创建组件时 custObj 可能尚未就绪的问题
    '$store.state.custObj': {
      handler(newVal) {
        if (newVal) {
          this.custInfo = newVal
          // custObj 就绪后立即拉取消息偏好、日志和收藏列表
          this.getMessagePreference()
          this.getMessageLog()
          this.getShareFavoriteList()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.init()
  }
}
</script>
